import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { memo } from 'react';
import { CustomCheckboxProps } from '../../../interfaces';
import './styles.scss';

const CustomCheckbox: React.FC<CustomCheckboxProps> = props => {
  const { value, checked, onChange, name, type, className, ...rest } = props;

  const handleChange = (e: CheckboxChangeEvent) => {
    if (onChange) {
      if (className?.includes('controlledInput')) {
        onChange(e.target.checked as any);
      } else {
        onChange(e);
      }
    }
  };

  return (
    <Checkbox
      {...rest}
      checked={value ?? checked}
      onChange={handleChange}
      className={className}
    />
  );
};

export default memo(CustomCheckbox);
